/** IVR builder GraphQL operations. `nodes` is a JSON scalar; the hook normalizes it to IvrNodeWire[] at the boundary. */

import { graphql } from 'app/generated/gql'

export const IVR_PHONE_NUMBERS_QUERY = graphql(`
  query IvrPhoneNumbers($search: String, $pagination: PaginationInput) {
    phoneNumbers(search: $search, pagination: $pagination) {
      hits {
        id
        phone
        roles
        label
      }
    }
  }
`)

export const IVR_CONFIG_QUERY = graphql(`
  query IvrConfig($phoneNumberId: String!) {
    ivrConfig(phoneNumberId: $phoneNumberId) {
      id
      locationId
      phoneNumberId
      enabled
      root
      nodes
    }
  }
`)

export const IVR_CONFIGS_QUERY = graphql(`
  query IvrConfigs($locationId: String!) {
    ivrConfigs(locationId: $locationId) {
      id
      phoneNumberId
    }
  }
`)

export const CREATE_IVR_CONFIG_MUTATION = graphql(`
  mutation CreateIvrConfig($input: SaveIvrConfigInput!) {
    createIvrConfig(input: $input) {
      id
      locationId
      phoneNumberId
      enabled
      root
      nodes
    }
  }
`)

export const UPDATE_IVR_CONFIG_MUTATION = graphql(`
  mutation UpdateIvrConfig($input: SaveIvrConfigInput!) {
    updateIvrConfig(input: $input) {
      id
      locationId
      phoneNumberId
      enabled
      root
      nodes
    }
  }
`)
